export function readTraceId(value: unknown): string | undefined {
    if (typeof value !== "string") return undefined;

    const root = value
        .split(";")
        .map(part => part.trim())
        .find(part => part.startsWith("Root="));
    const traceId = root ? root.slice(5) : value;

    return traceId.length === 35 &&
    /^1-[0-9a-fA-F]{8}-[0-9a-fA-F]{24}$/.test(traceId)
        ? traceId
        : undefined;
}
